import Language from './language.vue'
export default Language



// WEBPACK FOOTER //
// ./src/view/main/components/language/index.js